import { z } from "zod";

export const addressSchema = z.object({
  street_address: z.string().nullable().optional(),
  city: z.string().nullable().optional(),
  region: z.string().nullable().optional(),
  postal_code: z.preprocess(
    (val) => (typeof val === "number" ? String(val) : val),
    z.string().nullable().optional(),
  ),
  country: z.string().nullable().optional(),
});

export type Address = z.infer<typeof addressSchema>;
